import React from "react";

/**
 * Segmented switch that flips the sidebar between Company and Supplier views.
 *
 * Rendered only when the current instance can toggle (i.e. not the
 * supplier-only build). The active segment uses the global accent token
 * so it visually echoes other primary actions in the header.
 */
const SectionToggle = ({ section, onToggle, sections }) => {
  const isSupplier = section === sections.SUPPLIER;

  const baseSegment = {
    border: 0,
    background: "transparent",
    color: "var(--ink-3)",
    fontFamily: "var(--font-sans)",
    fontSize: 13,
    fontWeight: 600,
    padding: "6px 12px",
    borderRadius: 999,
    cursor: "pointer",
    transition: "background-color 0.2s ease, color 0.2s ease",
    lineHeight: 1,
  };

  const activeSegment = {
    background: "var(--accent)",
    color: "var(--surface)",
    boxShadow: "0 1px 2px rgba(0,0,0,0.08)",
  };

  const select = (target) => {
    if (target !== section) onToggle();
  };

  return (
    <div
      role="group"
      aria-label="Sidebar view"
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 2,
        padding: 3,
        borderRadius: 999,
        background: "var(--surface-3)",
        border: "1px solid var(--rule)",
      }}
    >
      <button
        type="button"
        aria-pressed={!isSupplier}
        onClick={() => select(sections.COMPANY)}
        style={{ ...baseSegment, ...(isSupplier ? {} : activeSegment) }}
      >
        Company
      </button>
      <button
        type="button"
        aria-pressed={isSupplier}
        onClick={() => select(sections.SUPPLIER)}
        style={{ ...baseSegment, ...(isSupplier ? activeSegment : {}) }}
      >
        Supplier
      </button>
    </div>
  );
};

export default SectionToggle;
